import { render, staticRenderFns } from "./DocumentSimilarityPanel.vue?vue&type=template&id=008bc176&scoped=true"
import script from "./DocumentSimilarityPanel.vue?vue&type=script&lang=js"
export * from "./DocumentSimilarityPanel.vue?vue&type=script&lang=js"
import style0 from "./DocumentSimilarityPanel.vue?vue&type=style&index=0&id=008bc176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008bc176",
  null
  
)

export default component.exports